/**
 * Wraps an element being compared, the comparison period and the
 * corresponding annual trend together.
 *
 * @param {AbstractBusinessTrendComparisonElement} comparisonElement - The element being compared: could be for a fiscal year or a budget.
 * @param {Period} period - The date period being compared.
 * @param {{}} annualTrendFetcher - An object being forwarded to
 * comparisonElement.fetchAnnualTrend().
 */
export default class BusinessTrendComparisonData {
	constructor({ comparisonElement, period, annualTrendFetcher }) {
		this._comparisonElement = comparisonElement;
		this._period = period;
		this._annualTrendFetcher = annualTrendFetcher;

		this._annualTrend = undefined;
	}

	getPeriod() {
		return this._period;
	}

	getName() {
		return this._comparisonElement.getName();
	}

	getPeriodLabels() {
		return this._annualTrend.periodLabels;
	}

	getProfitTrend() {
		return this._annualTrend.profitTrend;
	}

	getAccumulatedProfitTrend() {
		return this._annualTrend.accumulatedProfitTrend;
	}

	getIncomeTrend() {
		return this._annualTrend.incomeTrend;
	}

	getAccumulatedIncomeTrend() {
		return this._annualTrend.accumulatedIncomeTrend;
	}

	getTrendValues() {
		return this._annualTrend.getValuesForPeriod(
			this._period,
			this._period.getYear().asMonths(),
		);
	}

	getNameRenderer({ router }) {
		return this._comparisonElement.getNameRenderer({ router });
	}

	getPeriodNameRenderer({ router }) {
		return this._comparisonElement.getPeriodNameRenderer({
			period: this._period,
			router,
		});
	}

	async fetchAnnualTrend() {
		this._annualTrend = await this._comparisonElement.fetchAnnualTrend(
			this._annualTrendFetcher,
		);
	}
}
